/* Sunday Paw Club — theme behaviour. No dependencies, no build step. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  var revealables = document.querySelectorAll('.rv');
  if (!('IntersectionObserver' in window) || reduce) {
    revealables.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });
    revealables.forEach(function (el, i) {
      el.style.transitionDelay = ((i % 4) * 90) + 'ms';
      io.observe(el);
    });
  }

  /* ---------- Header shadow once you leave the top ---------- */
  var hdr = document.querySelector('.hdr');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('is-stuck', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector('[data-menu]');
  if (drawer) {
    var openBtn = document.querySelector('[data-menu-open]');
    var openDrawer = function () {
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-on'); });
      document.body.classList.add('is-locked');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    };
    var closeDrawer = function () {
      drawer.classList.remove('is-on');
      document.body.classList.remove('is-locked');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
      setTimeout(function () { drawer.hidden = true; }, 450);
    };
    if (openBtn) openBtn.addEventListener('click', openDrawer);
    drawer.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !drawer.hidden) closeDrawer();
    });
  }

  /* ---------- Stock bar ---------- */
  document.querySelectorAll('[data-stock-fill]').forEach(function (el) {
    requestAnimationFrame(function () { el.style.width = el.dataset.stockFill + '%'; });
  });

  /* ---------- Honest cut-off timer ----------
     Counts down to the dispatch cut-off in the shop's own day. After the
     cut-off it says so, instead of resetting to a fake 23:59. */
  document.querySelectorAll('[data-cutoff]').forEach(function (box) {
    var out = box.querySelector('[data-timer-out]');
    if (!out) return;
    var hour = parseInt(box.dataset.cutoff, 10);
    var tpl = box.dataset.template || '{timer}';
    var after = box.dataset.after || '';

    var tick = function () {
      var now = new Date();
      var end = new Date(now);
      end.setHours(hour, 0, 0, 0);
      var day = now.getDay();
      if (now >= end || day === 0 || day === 6) { out.textContent = after; return; }
      var left = Math.floor((end - now) / 1000);
      var h = Math.floor(left / 3600);
      var mm = Math.floor((left % 3600) / 60);
      var s = left % 60;
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      out.textContent = tpl.replace('{timer}', (h > 0 ? h + 'h ' : '') + pad(mm) + 'm ' + pad(s) + 's');
    };
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Copy a discount code ---------- */
  document.querySelectorAll('[data-copy]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (navigator.clipboard) navigator.clipboard.writeText(b.dataset.copy);
      b.classList.add('is-copied');
      setTimeout(function () { b.classList.remove('is-copied'); }, 1800);
    });
  });

  /* ---------- Product page ---------- */
  var form = document.querySelector('[data-buy-form]');
  var dataTag = document.querySelector('[data-variant-data]');
  if (form && dataTag) {
    var variants = [];
    try { variants = JSON.parse(dataTag.textContent); } catch (e) { variants = []; }

    var idField = form.querySelector('[data-variant-id]');
    var priceOut = document.querySelector('[data-price]');
    var compareOut = document.querySelector('[data-compare]');
    var addLabel = form.querySelector('[data-add-label]');
    var addBtn = form.querySelector('[data-add-btn]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyVariant = document.querySelector('[data-sticky-variant]');

    /* Which option carries the colour. The template resolves it by name and
       writes it here, because the pickers are no longer printed in option
       order: colour sits under the title, everything else above the button. */
    var colourIdx = parseInt(form.dataset.colorOption, 10);
    if (isNaN(colourIdx) || colourIdx < 0) colourIdx = 0;

    /* The gallery holds every colour. We keep the full set in memory and put
       back only the slides tagged with the chosen colour, so the shopper
       sees that colour and nothing else — and the photos of the other
       colours are never in the document, so they are never downloaded. */
    var gal = document.querySelector('.gal');
    var allSlides = gal ? Array.prototype.slice.call(gal.querySelectorAll('[data-gal-slide]')) : [];

    var showColour = function (colour) {
      if (!gal || !allSlides.length) return;
      var keep = allSlides.filter(function (s) {
        return !colour || !s.dataset.color || s.dataset.color === colour;
      });
      if (!keep.length) keep = allSlides;
      if (keep.length === gal.children.length) {
        var same = true;
        for (var i = 0; i < keep.length; i++) {
          if (gal.children[i] !== keep[i]) { same = false; break; }
        }
        if (same) return;
      }
      gal.replaceChildren.apply(gal, keep);
      gal.scrollLeft = 0;
    };

    /* Index each radio by its own option number, not by the order the
       pickers happen to appear in. Reading them in document order would
       silently swap colour and size the moment the buy box is rearranged. */
    var chosen = function () {
      var opts = [];
      form.querySelectorAll('[data-option-input]:checked').forEach(function (i) {
        opts[parseInt(i.dataset.optionInput, 10)] = i.value;
      });
      return opts;
    };

    var findVariant = function (opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) {
          if (v.options[j] !== opts[j]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    };

    /* Grey out the sizes that do not exist in the chosen colour. */
    var markUnavailable = function (opts) {
      form.querySelectorAll('[data-option-input]').forEach(function (input) {
        var idx = parseInt(input.dataset.optionInput, 10);
        var test = opts.slice();
        test[idx] = input.value;
        var v = findVariant(test);
        var label = input.nextElementSibling;
        if (label) label.classList.toggle('is-out', !(v && v.available));
      });
    };

    var sync = function () {
      var opts = chosen();
      var v = findVariant(opts);

      form.querySelectorAll('[data-option-selected]').forEach(function (el) {
        var idx = parseInt(el.dataset.optionSelected, 10);
        if (opts[idx]) el.textContent = opts[idx];
      });

      markUnavailable(opts);
      showColour(opts[colourIdx]);

      if (!v) {
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (addBtn) addBtn.disabled = true;
        return;
      }

      if (idField) idField.value = v.id;
      if (priceOut) priceOut.textContent = v.price;
      if (stickyPrice) stickyPrice.textContent = v.price;
      if (stickyVariant) stickyVariant.textContent = opts.join(' / ');
      if (compareOut) {
        compareOut.textContent = v.hasCompare ? v.compare : '';
        compareOut.hidden = !v.hasCompare;
      }
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      }
    };

    form.querySelectorAll('[data-option-input]').forEach(function (input) {
      input.addEventListener('change', sync);
    });
    sync();

    /* Quantity */
    var qty = form.querySelector('[data-qty]');
    if (qty) {
      var field = qty.querySelector('input');
      qty.querySelectorAll('[data-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(field.value, 10) || 1;
          field.value = Math.max(1, b.dataset.step === 'up' ? n + 1 : n - 1);
        });
      });
    }

    /* "Not sure which size" opens the right accordion */
    document.querySelectorAll('[data-open-sizes]').forEach(function (b) {
      b.addEventListener('click', function () {
        var acc = document.getElementById('sizes-acc');
        if (!acc) return;
        acc.open = true;
        acc.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      });
    });

    /* Sticky bar: appears once the real button has scrolled away */
    var satc = document.querySelector('.satc');
    if (satc && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        satc.classList.toggle('is-on', !entries[0].isIntersecting);
      }, { rootMargin: '-90px 0px 0px 0px' }).observe(addBtn);

      var stickyBtn = satc.querySelector('[data-sticky-buy]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      });
    }
  }

  /* ---------- Newsletter popup ---------- */
  var pop = document.getElementById('nl-pop');
  if (pop) {
    var KEY = 'spc_nl';
    var PAUSE = 14 * 24 * 60 * 60 * 1000;
    var state = {};
    try { state = JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) {}
    var remember = function (patch) {
      Object.keys(patch).forEach(function (k) { state[k] = patch[k]; });
      try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    };

    var isOpen = false;
    var openPop = function () {
      if (isOpen) return;
      isOpen = true;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-on'); });
      document.body.classList.add('is-locked');
      var f = pop.querySelector('input[type="email"]');
      if (f) f.focus();
    };
    var closePop = function () {
      if (!isOpen) return;
      isOpen = false;
      pop.classList.remove('is-on');
      document.body.classList.remove('is-locked');
      setTimeout(function () { pop.hidden = true; }, 420);
      remember({ closed: Date.now() });
    };
    pop.querySelectorAll('[data-pop-close]').forEach(function (el) { el.addEventListener('click', closePop); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePop(); });

    if (location.search.indexOf('customer_posted=true') > -1) {
      remember({ subscribed: true });
      openPop();
    } else if (!state.subscribed && !(state.closed && Date.now() - state.closed < PAUSE)) {
      var t = setTimeout(openPop, document.body.classList.contains('halloween-takeover') ? 45000 : 14000);
      window.addEventListener('scroll', function onS() {
        if (window.scrollY + window.innerHeight > document.body.scrollHeight * 0.55) {
          window.removeEventListener('scroll', onS);
          clearTimeout(t);
          openPop();
        }
      }, { passive: true });
    }
  }
})();
